import type { FilterData } from '@/js/types/filter.ts';
import { LOCALE } from '@/js/api/const.ts';
import { i18n } from '@/js/i18n/i18n.ts';
import CategoryFilters from '@/js/vue/filter/category-filters.vue';
import { createApp } from 'vue';

const FILTERS_SELECTOR = '.vue-category-filters';
const filtersElement = document.querySelector<HTMLElement>(FILTERS_SELECTOR);

function getFiltersData() {
  return (window.categoryFilters ?? null) as FilterData;
}

export async function initCategoryFilters() {
  if (!filtersElement)
    return;

  const app = createApp(CategoryFilters, {
    filterData: getFiltersData(),
    categoryId: window.categoryId ?? null,
    appliedFilters: window.activeFilters ?? [],
  });

  i18n.global.locale = LOCALE;
  app.use(i18n);
  app.mount(filtersElement);
}
